import { render } from "./BookingCCPage.vue?vue&type=template&id=f273d058&scoped=true"
import script from "./BookingCCPage.vue?vue&type=script&lang=js"
export * from "./BookingCCPage.vue?vue&type=script&lang=js"

import "./BookingCCPage.vue?vue&type=style&index=0&id=f273d058&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f273d058"]])

export default __exports__